import React from 'react';
import { TableModifier, Table, TableHead, TableRow, TableCell, TableBody } from '../../../../../organisms/Table';
import { ContentParagraph } from '../../../../../../_lib/components/ContentParagraph';
import { EditorHelpShortcutRow } from './EditorHelpShortcutRow';
import { shortCuts } from './shortCuts';
import { useSonTranslation } from '../../../../../../translation/useSonTranslation';
import { SONEditorConfig } from '../types';

export type EditorHelpProps = {
  config?: SONEditorConfig;
};

export function EditorHelp({ config }: EditorHelpProps) {
  const { t } = useSonTranslation('Editor');
  const tableCellModifier = [TableModifier.LOWPADDING, TableModifier.DARKBORDER];
  return (
    <div className="editor__help">
      <ContentParagraph>{t('helpText')}</ContentParagraph>
      <Table caption={t('helpCaption')}>
        <TableHead>
          <TableRow>
            <TableCell modifier={tableCellModifier}>{t('tableHeadAction')}</TableCell>
            <TableCell modifier={tableCellModifier}>{t('tableHeadShortcut')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody key="body-editor-table">
          {shortCuts(t, config).map(item => (
            <EditorHelpShortcutRow key={item.action} action={item.action} shortcut={item.shortcut} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
